export interface FormDatePickerTranslations {
	[index: string]: {
		weekday: number;
		labels: {
			[index: string]: string;
		};
	};
}

export interface FormTimePickerTranslations {
	[index: string]: {
		labels: {
			[index: string]: string;
		};
	};
}

export const formDatePickerTranslations: FormDatePickerTranslations = {
	'en-gb': {
		weekday: 1,
		labels: {
			labelPrevDecade: 'Previous decade',
			labelPrevYear: 'Previous year',
			labelPrevMonth: 'Previous month',
			labelCurrentMonth: 'Current month',
			labelNextMonth: 'Next month',
			labelNextYear: 'Next year',
			labelNextDecade: 'Next decade',
			labelToday: 'Today',
			labelSelected: 'Selected date',
			labelNoDateSelected: 'No date selected',
			labelCalendar: 'Calendar',
			labelNav: 'Calendar navigation',
			labelHelp: 'Use cursor keys to navigate calendar dates',
			labelCloseButton: 'Close',
			labelTodayButton: 'Select today',
			labelResetButton: 'Reset',
		},
	},
	fr: {
		weekday: 1,
		labels: {
			labelPrevDecade: 'Décennie précédente',
			labelPrevYear: 'Année précédente',
			labelPrevMonth: 'Mois précédent',
			labelCurrentMonth: 'Mois courant',
			labelNextMonth: 'Mois prochain',
			labelNextYear: "L'année prochaine",
			labelNextDecade: 'Décennie prochaine',
			labelToday: "Aujourd'hui",
			labelSelected: 'Date choisie',
			labelNoDateSelected: 'Aucune date sélectionnée',
			labelCalendar: 'Calendrier',
			labelNav: 'Navigation dans le calendrier',
			labelHelp: 'Utilisez les touches du curseur pour naviguer dans les dates du calendrier',
			labelCloseButton: 'Fermer',
			labelTodayButton: "Sélectionnez aujourd'hui",
			labelResetButton: 'Réinitialiser',
		},
	},
};

export const formTimePickerTranslations: FormTimePickerTranslations = {
	'en-gb': {
		labels: {
			labelHours: 'Hours',
			labelMinutes: 'Minutes',
			labelSeconds: 'Seconds',
			labelIncrement: 'Increment',
			labelDecrement: 'Decrement',
			labelSelected: 'Selected time',
			labelNoTimeSelected: 'No time selected',
			labelCloseButton: 'Close',
			labelNowButton: 'Select now',
			labelResetButton: 'Reset',
		},
	},
	fr: {
		labels: {
			labelHours: 'Heures',
			labelMinutes: 'Minutes',
			labelSeconds: 'Seconds',
			labelIncrement: 'Incrément',
			labelDecrement: 'Décrémenter',
			labelSelected: 'Heure sélectionnée',
			labelNoTimeSelected: 'Aucune heure sélectionnée',
			labelCloseButton: 'Fermer',
			labelNowButton: 'Sélectionnez maintenant',
			labelResetButton: 'Réinitialiser',
		},
	},
};
